"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.video50 = void 0;
var util_1 = require("./util");
var video50 = function (event) {
    return (0, util_1.videoEvent)(event, "video-50");
};
exports.video50 = video50;
